/* global Config */

// Vendor Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '../core/icon';
import Loading from '../core/loading';
import Permissions from '../core/permissions';

// Containers
import withPermissions from '../../containers/with-permissions';

// Styles
import './earl-iframe-container.scss';

export class EarlIframeContainer extends Component {
  headerHeight = 60;

  iFrameLoadErrorTimeout = null;

  state = {
    earlHasLoadedInIFrame: false,
    hasErrorLoadingIFrame: false,
    isLoadingEarlIFrame: false,
    isAuthorized: false,
    errorMessage: '',
  };

  componentWillMount() {
    const { hasAccessByRole } = this.props;
    if (hasAccessByRole({ allowRoles: ['est_admin'] })) {
      this.setState((prevState) => ({
        ...prevState,
        isLoadingEarlIFrame: true,
        isAuthorized: true,
      }));
      this.iFrameLoadErrorTimeout = setTimeout(this.onIFrameLoadError, 10000);
    } else {
      this.onUnauthorizedUser();
    }
  }

  componentWillUnmount() {
    clearInterval(this.iFrameLoadErrorTimeout);
  }

  onUnauthorizedUser = () => {
    this.generateError('User is not authorized to access this resource');
  };

  onIFrameLoadError = () => {
    this.generateError('Something went wrong while loading Earl');
  };

  onIFrameLoad = () => {
    clearTimeout(this.iFrameLoadErrorTimeout);

    this.setState((prevState) => ({
      ...prevState,
      errorMessage: '',
      hasErrorLoadingIFrame: false,
      earlHasLoadedInIFrame: true,
      isLoadingEarlIFrame: false,
    }));
  };

  generateError = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      errorMessage: message,
      earlHasLoadedInIFrame: false,
      hasErrorLoadingIFrame: true,
    }));
  };

  renderErrorMessage = (errorMessage) => (
        <div className="error-message">
            <Icon className="error-message__icon" fontType="fa" iconName="times" />
            <p className="error-message__text">
                <span className="error-message__text__error-text">Error:</span>&nbsp;
                {errorMessage}
            </p>
        </div>
  );

  generateIFrameClasses = (hasIFrameLoaded, headerHeight) => `earl-iframe ${hasIFrameLoaded ? 'shown' : 'hidden'} full-height-minus-${headerHeight}-pixels`;

    render() {
        const {
            earlHasLoadedInIFrame,
            isLoadingEarlIFrame,
            hasErrorLoadingIFrame,
            errorMessage,
            isAuthorized,
        } = this.state;

    return (
            <Permissions adminOnly={true} autoRedirect={true}>
                {isAuthorized && !hasErrorLoadingIFrame && (
                    <>
                        <iframe
                            allowFullScreen={true}
                            className={this.generateIFrameClasses(earlHasLoadedInIFrame, this.headerHeight)}
                            src={Config.base.earlUrl}
                            title="Earl iFrame"
                            onLoad={this.onIFrameLoad}
                        />
                        {isLoadingEarlIFrame && <Loading loading={true} />}
                    </>
                )}
                {hasErrorLoadingIFrame && this.renderErrorMessage(errorMessage)}
            </Permissions>
    );
  }
}

EarlIframeContainer.propTypes = {
  hasAccessByRole: PropTypes.func.isRequired,
};

export default withPermissions(EarlIframeContainer);
